<chat-mensagem-header class="chat-header"
  [chat]="chat()"
  (fecharChatHandler)="fechar()"
  (chatFormHandler)="chatForm($event)"
  (sairChatHandler)="removerParticipante($event)"
  (excluirChatHandler)="excluirChat($event)"
  (chatParticipantesHandler)="chatParticipantes($event)">
</chat-mensagem-header>
@if (chat().grupo && chat().chatParticipante?.administrador) {
  <div class="chat-header">
    <mat-toolbar class="chat-toolbar">
      <mat-toolbar-row>
        <form [formGroup]="participanteForm" name="participanteForm"
          (ngSubmit)="adicionarParticipante()"
          (keydown.enter)="adicionarParticipante(); $event.preventDefault();">
          <div class="search-wrapper flex flex-row justify-start items-center content-center grow shrink basis-0">
            <div class="search flex flex-row justify-start items-center content-center">
              <mat-icon class="text-base w-16 h-16 text-secondary">search</mat-icon>
              <input
                tabindex="-1"
                #usuarioInput
                class="flex"
                placeholder="Adicionar usuário..."
                formControlName="usuario"
                [matAutocomplete]="usuario.autocomplete()"
                (blur)="checkUsuario()"
                required>
            </div>
          </div>
          <cdk-usuario-autocomplete
            #usuario="usuarioAutocomplete"
            [control]="participanteForm.get('usuario')"
            [pagination]="usuarioPagination">
          </cdk-usuario-autocomplete>
          @if (!saving()) {
            <button type="submit" mat-icon-button
              [disabled]="participanteForm.invalid">
              <mat-icon class="text-secondary">done</mat-icon>
            </button>
          }
          @if (saving()) {
            <mat-spinner color="primary" diameter="24"></mat-spinner>
          }
        </form>
      </mat-toolbar-row>
    </mat-toolbar>
  </div>
}
@if (errorMessage) {
  <mat-error class="chat-participantes-error">
    {{errorMessage}}
  </mat-error>
}
<div class="content"
  infiniteScroll
  [scrollWindow]="false"
  [infiniteScrollDistance]="5"
  [infiniteScrollThrottle]="150"
  (scrolled)="scrollDown()">
  @for (participante of chatParticipanteList() | sortByDate: 'criadoEm':'DESC':false; track participante.id) {
    <div class="chat-participantes-list-item">
      <div class="chat-profile">
        <div class="avatar-wrapper">
          <chat-imagem [imagem]="participante.usuario.imgPerfil">
          </chat-imagem>
        </div>
        <div class="chat-info">
          <div class="chat-profile-name">
            {{participante.usuario.nome}}
          </div>
          @if (participante.administrador) {
            <div class="chat-role">
              Administrador
            </div>
          }
        </div>
      </div>
      @if (chat().chatParticipante?.administrador && participante.id !== chat().chatParticipante?.id) {
        <div class="chat-participantes-actions"
          >
          @if (!saving()) {
            <button mat-icon-button
              [matMenuTriggerFor]="chatParticipanteMenu"
              aria-label="more">
              <mat-icon>more_vert</mat-icon>
            </button>
          }
          <mat-menu #chatParticipanteMenu="matMenu">
            @if (!participante.administrador) {
              <button mat-menu-item (click)="tornarAdministrador(participante)">
                Tornar Administrador
              </button>
            }
            <button mat-menu-item (click)="removerParticipante(participante)">
              Excluir Participante
            </button>
          </mat-menu>
        </div>
      }
    </div>
  }
  @if (loading()) {
    <mat-spinner color="primary" class="loading" color="primary" diameter="24"></mat-spinner>
  }
</div>
